enum ParentshipTypeEnum {
  None = 0,
  Father = 1,
  Mother = 2,
  Custodian = 3,
}

export default ParentshipTypeEnum;
